import { useMemo, ReactNode } from 'react';
import { Button, Colors } from '@mercator-gcp/grout';
import Tooltip from 'components/elements/Tooltip';
import type { ButtonProps } from '@mercator-gcp/grout';

const unsavedButtonStyle = {
  border: '1px solid',
  borderRadius: '4px',
  borderColor: Colors.ArmyGreen200,
  padding: 'padding_8',
  paddingLeft: 'padding_12',
  paddingRight: 'padding_12',
  justifyContent: 'flex-start',
  '&:hover, &:focus': {
    border: '1px solid',
    paddingY: 'padding_8',
    paddingX: 'padding_12',
    borderColor: Colors.ArmyGreen200,
    backgroundColor: Colors.ArmyGreen100,
  },
};

const onHoverStyle = {
  borderRadius: '50%',
  padding: 'padding_8',
  transition: 'background-color 0.2s ease',
  '&:hover, &:focus': {
    backgroundColor: Colors.ArmyGreen200,
  },
};

type TUnsavedProjectButtonProps = {
  label: string;
  variant: 'styled' | 'unstyled';
  sx?: ButtonProps['sx'];
  onClick: ButtonProps['onClick'];
  icon: ReactNode;
};

const UnsavedProjectButton = ({
  label,
  variant = 'styled',
  sx = {},
  onClick,
  icon,
}: TUnsavedProjectButtonProps) => {
  const unsavedProjectStyle = useMemo(() => {
    if (variant === 'unstyled') {
      return { ...sx, ...onHoverStyle };
    }

    return { ...sx, ...unsavedButtonStyle };
  }, [sx, variant]);

  const pinColor = useMemo(() => {
    if (variant === 'unstyled') {
      return Colors.ArmyGreen500;
    }

    return Colors.Black800;
  }, [sx, variant]);

  return (
    <Tooltip tooltipText={label} placement="bottom">
      <Button
        sx={{ ...unsavedProjectStyle, color: pinColor }}
        variant="unstyled"
        onClick={onClick}
      >
        {icon}
      </Button>
    </Tooltip>
  );
};

export default UnsavedProjectButton;
